import { useMemo } from 'react';

import { useEnv } from '@/src/application/hooks/util/useEnv';
import configData from '@/src/config.json';
import { APIService } from '@/src/infrastructure/Protocol/APIService';

import { DashboardService } from './DashboardService';
import { StubDashboardService } from './StubDashboardService';

export const useDashboardService = () => {
  const { env } = useEnv();

  const service = useMemo(() => {
    if (env !== 'storybook') {
      const { URL_EMA_APP, JWT_DEV_TOKEN } = configData.endpoints[env];

      const jwt =
        JWT_DEV_TOKEN !== ''
          ? JWT_DEV_TOKEN
          : (window as Window & typeof globalThis & { __JWTToken: string }).__JWTToken;

      return DashboardService.create({
        api: new APIService(''),
        jwt: jwt,
        url_ema_app_v1: URL_EMA_APP,
      });
    } else {
      return StubDashboardService.create();
    }
  }, [env]);

  return service;
};
